/**
 * Минимальный разбор semver для правил повторного показа (ТЗ §3.1, ADR-050).
 *
 * Учитывается только ядро `MAJOR.MINOR.PATCH`: pre-release и build-метаданные
 * (`0.2.0+1841` из `VITE_RELEASE`) на объём повторного показа не влияют.
 */

export interface SemanticVersion {
  major: number;
  minor: number;
  patch: number;
}

export type VersionBump = 'none' | 'patch' | 'minor' | 'major' | 'downgrade';

const SEMVER_CORE = /^(\d+)\.(\d+)\.(\d+)(?:[-+].*)?$/;

export function parseSemver(value: string | null | undefined): SemanticVersion | null {
  if (!value) return null;
  const match = SEMVER_CORE.exec(value.trim());
  if (!match) return null;
  return { major: Number(match[1]), minor: Number(match[2]), patch: Number(match[3]) };
}

export function compareSemver(a: SemanticVersion, b: SemanticVersion): number {
  if (a.major !== b.major) return a.major - b.major;
  if (a.minor !== b.minor) return a.minor - b.minor;
  return a.patch - b.patch;
}

/** Насколько версия `to` выросла относительно `from`. Неразбираемая `from` = первый показ. */
export function versionBump(from: string | null | undefined, to: string): VersionBump {
  const previous = parseSemver(from);
  const current = parseSemver(to);
  if (!current) return 'none';
  if (!previous) return 'major';
  if (current.major !== previous.major) return current.major > previous.major ? 'major' : 'downgrade';
  if (current.minor !== previous.minor) return current.minor > previous.minor ? 'minor' : 'downgrade';
  if (current.patch !== previous.patch) return current.patch > previous.patch ? 'patch' : 'downgrade';
  return 'none';
}
